import React from "react";
import "./HeroSection.css";

const HeroSection = () => {
  return (
    <section className="hero">
      <div className="hero-bg">
        <div className="hero-grid"></div>
        <div className="hero-glow"></div>
      </div>

      <div className="hero-content">
        <div className="hero-badge">
          <span className="badge-dot"></span>
          BECOME THE BEST VERSION OF YOURSELF
        </div>

        <h1 className="hero-title hero-title-smaller">
          <span className="title-stack">
            <span className="title-line">
              <span className="title-initial gold">D</span>one
            </span>
            <span className="title-line">
              <span className="title-initial gold">W</span>ith
            </span>
            <span className="title-line">
              <span className="title-initial gold">G</span>reatness
            </span>
          </span>
        </h1>

        <p className="hero-subtitle">
          DWG Labs creates elite applications designed to push you beyond your
          limits. No excuses. No shortcuts. Just results.
        </p>

        <div className="hero-cta">
          <a href="#apps" className="btn btn-primary">
            Explore Our Apps
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </a>
          <a href="#stats" className="btn btn-outline">
            See Our Impact
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
